import React from "react";
const config = require("../config");
const helper = require("../helper");
const Modal = require("../comp_misc").modal;
const helperFile = require("./user_helper.js");
const Pager = require("../comp_misc").pager;

// https://reactjs.org/docs/lists-and-keys.html react lists


var g_link = "/user/notifications";

function ListItem(props) {
  // Correct! There is no need to specify the key here:
  return <tr>
    <td>{props.item.date}</td><td>{props.item.priority}</td><td>{props.item.from}</td><td>{props.item.subject}</td><td>{props.item.view}</td>

</tr>

}

class ModalList1 extends React.Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      show: false,
      rows: null,
      name:null,
      email:"",
      error:null,
      image: null,
    };
  }




fillList()
{
  var rows1 = [];

  helper.getFromServer(g_link+"?dw=get")
  .then(res => {

    this.setState({showForm: false, rows: res.result, options: res.options, count: res.options.count});
  })



}
 componentDidMount() {
  this.fillList()  
  }

    

  render() {
document.title = "Notifications";

let spinner;
let pager;
if (!this.state.rows)
{
  spinner = <div class="d-flex justify-content-center">
  <div class="spinner-border spinner text-primary" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>;
}
else
{
  pager = <Pager page={this.state.page} count={this.state.options.count} link={g_link}/>;
}


let listItems;
if (this.state.rows)
{


  listItems = this.state.rows.map((item, index) =>

    <ListItem key={index} item={item} parent={this} />
  );

}
return(
<div>
{helperFile.nav()}


    <div class="container my-4">
        <h2 class="text-primary mb-4"><i class="fa fa-envelope-open mr-2" aria-hidden="true"></i>Notifications</h2>

{/*<!-- user info block start -->*/}
        <div class="data-container">
            <div class="row mb-2">
                <div class="col-8">
                    <h4 class="text-success">Notifications inbox</h4>
                    <p>Your admin may send you messages or reminders, check it out on time.</p>
                </div>
                <div class="col-4">
                    <div class="card bg-secondary">
                        <div class="card-body text-center font-weight-bolder text-white">
                        Notifications: {this.state.count}
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

{/*<!-- filter search in flex container start -->*/}
            <div class="container d-flex my-4 px-0 justify-content-end">
                    <input class="form-control w-50" id="myInput" type="text" placeholder="Search.. by Date, Priority, From, Subject.."/>
            </div>
            
{/*<!-- attempts table list start -->*/}
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <table class="table mb-0 table-hover">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Priority</th>
                          <th scope="col">From</th>
                          <th scope="col">Subject</th>
                          <th scope="col">View</th>
                        </tr>
                      </thead>
                      {listItems}
                    </table>
                </div>
            </div>
        </div>
    </div>


    {pager}

 {helperFile.footer()}
 
</div>

)
}
}


export default ModalList1
